import {
    Heading,
    Text,
    Button,
    Flex,
    Link,
    View
  } from "@aws-amplify/ui-react";

  import DonutProgress from "./DonutProgress";
  
  export default function Ongoing({
    clientData,
    handleSubmit,
    loading,
  }) {
    return (
      <View textAlign="center">
        <br />
        <br />
        {clientData &&
        clientData.subscriptionPlan &&
        clientData.subscriptionPlan !== "none" ? (
          <>
            <Heading level={4}>Campaign status: Ongoing !</Heading>
            <br />
            <Text>Now, check tasks for your profile as influencers see it.</Text>
            <br />
            <Button
              onClick={() => handleSubmit("checkout", { checkout: true })}
              isLoading={loading}
              variation="primary"
              marginTop="1rem"
            >
              Start on Tasks
            </Button>
            <br />
            <br />
            <DonutProgress />
          </>
        ) : (
          <Flex justifyContent="center">
            <small>
              <br />
              Unlock with subscription{" "}
              <Link href="" onClick={() => handleSubmit("update")}>
                <u>here</u>
              </Link>
              <br />
              <br />
            </small>
          </Flex>
        )}
      </View>
    );
  }
  